import type { QueueTicket } from '@/features/queue/types';
import type { AllergyListItem } from '@/pages/patients/AllergyList';

export const clock = (iso: string) =>
  new Date(iso).toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
  });

/** "GP · MiCare · 10:02": service, payer and arrival. */
export function ticketLine(t: QueueTicket) {
  return [
    t.service?.name ?? 'Walk-in',
    t.payer?.name ?? 'Self-pay',
    clock(t.arrivedAt),
  ].join(' · ');
}

/** Who the vitals are for: a queue card, or the encounter's visit ("Retake"). */
export interface VitalsTarget {
  ticketId: string;
  number: number;
  service: string | null;
  patientName: string;
  dateOfBirth: string | null;
  allergies: AllergyListItem[];
}

export function vitalsTargetOf(t: QueueTicket): VitalsTarget {
  return {
    ticketId: t.id,
    number: t.number,
    service: t.service?.name ?? null,
    patientName: t.patient.fullName,
    dateOfBirth: t.patient.dateOfBirth,
    allergies: t.patient.allergies,
  };
}

export function ageOf(dateOfBirth: string | null): number | null {
  if (!dateOfBirth) return null;
  const dob = new Date(`${dateOfBirth}T00:00:00Z`);
  const now = new Date();
  let age = now.getUTCFullYear() - dob.getUTCFullYear();
  const m = now.getUTCMonth() - dob.getUTCMonth();
  if (m < 0 || (m === 0 && now.getUTCDate() < dob.getUTCDate())) age--;
  return age;
}
